import autobind from 'autobind-decorator';
import * as React from 'react';
import ReactDOM from 'react-dom';

import { ConstantFunctions } from '../../utils/constant-functions';
import { getOrCreateRoot } from '../../utils/dialog';
import { ContextMenu } from './context-menu';
import { Styled } from './styled';


export interface MovableContextMenuProps {
  x: number;
  y: number;
  onClose: (e: React.MouseEvent<HTMLDivElement>) => void;
  zIndex?: number;
  maxWidth?: number;
  pinBottom?: boolean;
}

const MARGIN = 40;

export class MovableContextMenu extends React.PureComponent<MovableContextMenuProps> {
  private dropDownRef: HTMLDivElement;

  public render(): React.ReactNode {
    return ReactDOM.createPortal(
      <>
        <ContextMenu getContainerRef={this.saveRef} zIndex={this.props.zIndex}>
          {this.props.children}
        </ContextMenu>
        <Styled.Blank
          zIndex={this.props.zIndex}
          onClick={this.props.onClose}
          onContextMenu={this.onContextBlanket}
        />
      </>,
      getOrCreateRoot(),
    );
  }

  public componentDidMount(): void {
    this.updatePosition();
  }


  public componentDidUpdate(prevProps: MovableContextMenuProps): void {
    if (prevProps.x !== this.props.x || prevProps.y !== this.props.y) {
      this.updatePosition();
    }
  }

  private onContextBlanket(e: React.MouseEvent<HTMLDivElement>): void {
    ConstantFunctions.stopEvent(e);
  }

  @autobind
  private saveRef(ref: HTMLDivElement): void {
    this.dropDownRef = ref;
  }

  @autobind
  private updatePosition(): void {
    const { x, y } = this.props;
    const dropDownRect = this.dropDownRef.getBoundingClientRect();
    const bottom = window.innerHeight - y;
    const topSpace = y - MARGIN;
    const bottomSpace = bottom - MARGIN;
    const isLeft = window.innerWidth / 2 > x;
    const left = isLeft ? x : x - dropDownRect.width;
    const isBottom = bottomSpace > topSpace;

    if (isBottom) {
      this.dropDownRef.style.top = `${y}px`;
    } else {
      this.dropDownRef.style.bottom = `${bottom}px`;
    }
    this.dropDownRef.style.maxHeight = `${isBottom ? bottomSpace : topSpace}px`;
    this.dropDownRef.style.left = `${left}px`;
    this.dropDownRef.style.animationDirection = 'normal';
    this.dropDownRef.style.transformOrigin = `${isLeft ? 'left' : 'right'} ${isBottom ? 'top' : 'bottom'}`;
  }
}
